export const IndicatorRecordingOff = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.3"
        cx="10.3333"
        cy="10"
        r="10"
        fill="#6F7086"
      />
      <circle
        cx="10.3333"
        cy="10"
        r="6"
        fill="#6F7086"
      />
    </svg>
  );
};
